<script>
    import { fade } from 'svelte/transition';
</script>

<div in:fade={{duration:800,delay:400}} out:fade={{duration:800,delay:0}} class="container flex flex-col justify-center items-center h-full text-left mx-auto my-0">
    <h3 class="text-2xl lg:text-6xl lg:text-4xl pb-10 xl:w-1/2 w-4/5" style="line-height:1.4em"><b> JavaScript specialist</b> with experience in React, Vue, Salesforce LWC and other front-end frameworks. 8+ years experience working alongside businesses to build and maintain clean and compelling websites and web applications. My work includes everything from exciting web apps to large scale e-commerce sites.
    </h3>
    <div class="justify-between flex xl:w-1/2 w-4/5">
        <div><img src="images/js-icon.png" alt="javascript" class="max-h-12 md:max-h-16"></div>
        <div><img src="images/react-icon.png" alt="wordpress" class="max-h-12 md:max-h-16"></div>
        <div><img src="images/vuejs-icon.png" alt="vuejs" class="max-h-12 md:max-h-16"></div>
        <div><img src="images/svelte-icon.png" alt="html" class="max-h-12 md:max-h-16"></div>
        <div><img src="images/php-icon.png" alt="php" class="max-h-12 md:max-h-16"></div>
    </div>
</div>